<template>
    <div class="el-table-container templateBox">
        <div class="query-form">
            <el-tabs v-model="searchForm.status" @tab-click="handleClick">
                <el-tab-pane v-for="item in pageTypeList" :key="item.name" :label="item.name"
                             :name="item.value"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="query-form">
            <el-button v-if="hasPermission('collection:store:applyFor:add')" type="primary" icon="el-icon-plus"
                       @click="addData('add')"
                       size="small">新建
            </el-button>
            <el-button v-if="hasPermission('collection:store:applyFor:submit')"
                       @click="submitData()" size="small">提交
            </el-button>
            <el-button v-if="hasPermission('collection:store:applyFor:export')"
                       @click="exportData()" size="small">导出
            </el-button>
            <el-button v-if="hasPermission('collection:store:applyFor:delete')"
                       @click="deleteDelete()" size="small">删除
            </el-button>
        </div>
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="90px">
            <el-form-item label="入库原因" prop="inWarehouseCause">
                <el-select v-model="searchForm.inWarehouseCause" clearable placeholder="请选择入库原因">
                    <el-option
                            v-for="item in $dictUtils.getDictList('in_warehouse_cause')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="预入库时间" prop="dataTime">
                <el-date-picker
                        v-model="searchForm.dataTime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
                <el-select v-model="searchForm.applicant" clearable placeholder="请选择申请人">
                    <el-option
                            v-for="item in applicantList"
                            :key="item.applicant"
                            :label="item.applicantName"
                            :value="item.applicant">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tips">
            <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
            已选择{{ dataListSelections.length }}项数据
        </div>
        <el-table
                :data="dataList"
                size="small" height="100%"
                class="table" ref="multipleTable" border
                @selection-change="selectionChangeHandle" row-key='id' v-loading="loading">
            <el-table-column type="selection" :reserve-selection='true' fixed/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="inWarehouseCause" label="入库原因" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("in_warehouse_cause", row.inWarehouseCause, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="inWarehouseTime" label="预入库时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicantName" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicantTime" label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="审批状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("collection_status", row.status, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="handleByName" label="审批人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="handleTime" label="审批时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" min-width="150">
                <template slot-scope="{row,$index}">
                    <el-button v-if="hasPermission('collection:store:applyFor:view')" type="text" size="small"
                               @click="addData('view',row)">详情
                    </el-button>
                    <el-button v-show="row.status == 0 || row.status == 3" v-if="hasPermission('collection:store:applyFor:edit')" type="text" size="small"
                               @click="addData('edit',row)">编辑
                    </el-button>
                    <el-button v-show="row.status == 0 || row.status == 3" v-if="hasPermission('collection:store:applyFor:submit')" type="text" size="small"
                               @click="submitData(row)">提交
                    </el-button>
                    <el-button v-show="row.status == 0 || row.status == 3" v-if="hasPermission('collection:store:applyFor:delete')" type="text"
                               size="small" @click="deleteDelete(row)">删除
                    </el-button>
                    <el-button v-show="row.status == 2" v-if="hasPermission('collection:outbound:outboundList:accept')" type="text"
                               size="small" @click="acceptData(row)">接收
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-apply-for ref="addApplyFor" @refresh="refreshList"></add-apply-for>
        <detail-store ref="detailStore"></detail-store>
        <sure-store ref="sureStore" @refresh="refreshList"></sure-store>
    </div>
</template>

<script>
import AddApplyFor from "@/views/modules/collection/store/addApplyFor.vue";
import DetailStore from "@/views/modules/collection/store/detailStore.vue";
import SureStore from "@/views/modules/collection/store/sureStore.vue";

export default {
    name: "applyFor",
    components: {SureStore, DetailStore, AddApplyFor},
    data() {
        return {
            searchForm: {
                status: '99',
                inWarehouseCause: '',
                dataTime: [],
                inWarehouseStartTime: '',
                inWarehouseEndTime: '',
                applicant: '',
                current: 1,
                size: 20,
            },
            applicantList: [],
            pageTypeList: [
                {
                    name: '全部',
                    value: '99',
                },
                {
                    name: '未提交',
                    value: '0',
                },
                {
                    name: '审核中',
                    value: '1',
                },
                {
                    name: '审核通过',
                    value: '2',
                },
                {
                    name: '审核驳回',
                    value: '3',
                },
            ],

            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,
            searchData:{},
        }
    },

    mounted() {
        this.refreshList()
        this.getOthers()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.searchData = JSON.parse(JSON.stringify(this.searchForm))
            if (this.searchData.status == '99') {
                this.searchData.status = ''
            }
            if (this.searchData.dataTime && this.searchData.dataTime.length) {
                this.searchData.inWarehouseStartTime = this.searchData.dataTime[0]
                this.searchData.inWarehouseEndTime = this.searchData.dataTime[1]
            } else {
                this.searchData.inWarehouseStartTime = ''
                this.searchData.inWarehouseEndTime = ''
            }
            this.$axios(this.api.collection.inWarehouseInfoQueryPage, this.searchData,'post').then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
            this.$axios(this.api.collection.tabCountInWarehouse).then(data => {
                if (data && data.status) {
                    this.pageTypeList = [
                        {
                            name: '全部',
                            value: '99',
                        },
                        {
                            name: '未提交',
                            value: '0',
                        },
                        {
                            name: '审核中',
                            value: '1',
                        },
                        {
                            name: '审核通过',
                            value: '2',
                        },
                        {
                            name: '审核驳回',
                            value: '3',
                        },
                    ]
                    this.pageTypeList[0].name += '(' + data.data.total + ')'
                    this.pageTypeList[1].name += '(' + data.data.noSubmit + ')'
                    this.pageTypeList[2].name += '(' + data.data.reviewIng + ')'
                    this.pageTypeList[3].name += '(' + data.data.reviewSuccess + ')'
                    this.pageTypeList[4].name += '(' + data.data.reviewRejected + ')'
                }
            })
        },

        //获取其他信息
        getOthers() {
            this.$axios(this.api.collection.inWarehouseInfoUserNameQueryPage,{},'post').then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        handleClick() {
            this.refreshList(1, 1)
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        // name add新增 view详情 edit编辑
        addData(name, row,index) {
            if (name == 'add'){
                this.$refs.addApplyFor.init()
            }
            if (name == 'view'){
                this.detailCurrt = (this.searchForm.current - 1) * this.searchForm.size + index + 1
                this.$refs.detailStore.init(row,'applyFor')
            }
            if (name == 'edit'){
                this.$refs.addApplyFor.init(row)
            }
        },

        //提交
        submitData(row) {
            let list = row ? [row] : this.dataListSelections
            if (!list.length) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let noSubList = []
            let ids = list.map(item => {
                if (item.status != 0 && item.status != 3) {
                    noSubList.push(item)
                }
                return item.id
            })
            if (noSubList.length) {
                this.$message.warning('只能提交未提交和已驳回的数据')
                return
            }
            this.$confirm(`确认提交所选信息？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.collection.collectioninwarehouseBatchSubmit, {id: ids}, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('提交成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //导出
        exportData() {
            let ids = this.dataListSelections.map(item => {
                return item.id
            })
            this.fileBlobDownload(this.api.collection.inWarehouseInfoQueryPageExport, {
                collectionOutWarehouseQueryDTO: this.searchData,
                ids,
            }, '入库申请', 'application/vnd.ms-excel')
        },

        //删除
        deleteDelete(row) {
            let list = row ? [row] : this.dataListSelections
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let noSubList = []
            let ids = list.map(item => {
                if (item.status != 0 && item.status != 3) {
                    noSubList.push(item)
                }
                return item.id
            })
            if (noSubList.length) {
                this.$message.warning('只能删除未提交和已驳回的数据')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.collection.collectioninwarehouseRemoveById, {ids}, 'post').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        acceptData(row){
            this.$refs.sureStore.init(row)
        },
    },
}
</script>

<style scoped>
.tips {
    padding: 4px;

    .el-icon-info {
        margin-right: 6px;
    }
}
</style>